// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"bec23629","321":"30e6350c","453":"32cd509f","455":"f4caee76","626":"875506d1","977":"84d294f9"}[chunkId] + ".chunk.js";
};